<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: 'Icon big'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=212-73558&m=dev'
 */
import type { IconDefinition } from '@fortawesome/pro-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/icon'
import { TooltipDefault } from '@shared/ui/tooltip'

defineOptions({
  name: 'BtnIcon',
})

withDefaults(defineProps<BtnIconProps>(), {
  disabled: false,
  color: 'blue',
  size: 'big',
  tooltip: null,
  dataQa: null,
})

const emit = defineEmits<{
  click: []
  'click:close': [Event]
}>()

interface BtnIconProps {
  icon: IconDefinition
  disabled?: boolean
  color?: 'blue' | 'gray' | 'transparent' | 'white'
  size?: 'big' | 'medium' | 'small'
  tooltip?: string | null
  dataQa?: string | null
}

const handleClick = (): void => {
  emit('click')
}
const handleClickClose = (event: Event): void => {
  emit('click:close', event)
}
</script>

<template>
  <button
    type="button"
    :class="['ui-btn-icon', color, size, { tooltip }]"
    :data-qa="dataQa"
    :disabled="disabled"
    @click="handleClick"
    @click.stop="handleClickClose"
  >
    <IconContainer
      is="span"
    >
      <FontAwesomeIcon
        :icon="icon"
      />
    </IconContainer>
    <TooltipDefault
      v-if="tooltip"
      :text="tooltip"
    />
  </button>
</template>

<style scoped lang="scss" src="./BtnIcon.scss" />
